var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("parameters", {
        ref: "params",
        attrs: { "representative-options": _vm.representativeOptions },
        on: { input: _vm.onInput },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function () {
              return [
                _vm.isDataLoaded
                  ? _c(
                      "el-button",
                      {
                        staticClass: "align-top",
                        attrs: { type: "primary" },
                        on: { click: _vm.download },
                      },
                      [_vm._v("Download")]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.hasParams
        ? _c("report-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isDataLoaded,
                expression: "isDataLoaded",
              },
            ],
            attrs: { url: _vm.url, params: _vm.params },
            on: { success: _vm.onSuccess, "validation-error": _vm.onError },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }